"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var date_range_model_1 = require("./date-range-model");
var formatting_service_1 = require("../../../service/formatting.service");
var SisDatesRangeViewComponent = /** @class */ (function () {
    function SisDatesRangeViewComponent(formattingService) {
        this.formattingService = formattingService;
        this.messageKey = 'portfolio.filter.invalidDate.message';
        this.errorMessageKey = '';
        this.changedValuesToBeEmitted = new date_range_model_1.DateRangeModel(undefined, undefined);
        this.valueChange = new core_1.EventEmitter();
    }
    SisDatesRangeViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formattingService.getLocaleInfo().subscribe(function (localeInfo) {
            _this.localeInfo = localeInfo;
        });
        this.startDateId = this._fieldName ? this._fieldName + "_dateFrom" : "dateFrom";
        this.endDateId = this._fieldName ? this._fieldName + "_dateTo" : "dateTo";
    };
    Object.defineProperty(SisDatesRangeViewComponent.prototype, "from", {
        get: function () {
            return this._from;
        },
        set: function (from) {
            this._from = from;
            if (this._from) {
                this._fromDate = new Date(this._from);
                this._fromDate = new Date(Date.UTC(this._fromDate.getFullYear(), this._fromDate.getMonth(), this._fromDate.getDate(), this._fromDate.getHours(), this._fromDate.getMinutes(), this._fromDate.getSeconds(), this._fromDate.getMilliseconds()));
            }
            else { //in case when reset button was clicked
                //in case when reset button was clicked
                this._fromDate = undefined;
            }
            this.changedValuesToBeEmitted.from = this._from;
            this.validateDateValues();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDatesRangeViewComponent.prototype, "to", {
        get: function () {
            return this._to;
        },
        set: function (to) {
            this._to = to;
            if (this._to) {
                this._toDate = new Date(this._to);
                this._toDate = new Date(Date.UTC(this._toDate.getFullYear(), this._toDate.getMonth(), this._toDate.getDate(), this._toDate.getHours(), this._toDate.getMinutes(), this._toDate.getSeconds(), this._toDate.getMilliseconds()));
            }
            else { //in case when reset button was clicked
                //in case when reset button was clicked
                this._toDate = undefined;
            }
            this.changedValuesToBeEmitted.to = this._to;
            this.validateDateValues();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDatesRangeViewComponent.prototype, "fieldName", {
        get: function () {
            return this._fieldName;
        },
        set: function (value) {
            this._fieldName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDatesRangeViewComponent.prototype, "fromDate", {
        get: function () {
            return this._fromDate;
        },
        set: function (from) {
            this._fromDate = from;
            if (this._fromDate) {
                this.changedValuesToBeEmitted.from = this._fromDate.getTime();
            }
            else {
                this.changedValuesToBeEmitted.from = null; //case when user removes start date filter
            }
            this.validateDateValues();
        },
        enumerable: true,
        configurable: true
    });
    SisDatesRangeViewComponent.prototype.changeValueFrom = function (from) {
        this._fromDate = from;
        if (this._fromDate) {
            this.changedValuesToBeEmitted.from = this._fromDate.getTime();
        }
        else {
            this.changedValuesToBeEmitted.from = null; //case when user removes start date filter
        }
        this.valueChange.emit(this.changedValuesToBeEmitted);
        this.validateDateValues();
    };
    Object.defineProperty(SisDatesRangeViewComponent.prototype, "toDate", {
        get: function () {
            return this._toDate;
        },
        set: function (to) {
            this._toDate = to;
            if (this._toDate) {
                this.changedValuesToBeEmitted.to = this._toDate.getTime();
            }
            else {
                this.changedValuesToBeEmitted.to = null; //case when user removes start date filter
            }
            this.validateDateValues();
        },
        enumerable: true,
        configurable: true
    });
    SisDatesRangeViewComponent.prototype.changeValueTo = function (to) {
        this._toDate = to;
        if (this._toDate) {
            this.changedValuesToBeEmitted.to = this._toDate.getTime();
        }
        else {
            this.changedValuesToBeEmitted.to = null; //case when user removes start date filter
        }
        this.valueChange.emit(this.changedValuesToBeEmitted);
        this.validateDateValues();
    };
    SisDatesRangeViewComponent.prototype.validateDateValues = function () {
        if (this.changedValuesToBeEmitted.from && this.changedValuesToBeEmitted.to
            && this.changedValuesToBeEmitted.from > this.changedValuesToBeEmitted.to) {
            this.errorMessageKey = this.messageKey;
        }
        else {
            this.errorMessageKey = '';
        }
    };
    SisDatesRangeViewComponent.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-date-range',
                    template: "\n\t\t<div #dataRangeElement *ngIf=\"localeInfo\" class=\"sis-portfolio-date-range\">\n\t\t\t<div fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n\t\t\t\t<div fxFlex=\"49\">\n\t\t\t\t\t<sis-date-picker\n\t\t\t\t\t\t\t[id]=\"startDateId\"\n\t\t\t\t\t\t\t[localeInfo]=\"localeInfo\"\n\t\t\t\t\t\t\t(dateChange) = changeValueFrom($event)\n\t\t\t\t\t\t\t[placeholder]=\"'portfolio.filter.date.range.choose.date' | sisTranslateMessage | async\"\n\t\t\t\t\t\t\t[ngModel]=\"fromDate\"\n\t\t\t\t\t></sis-date-picker>\n\t\t\t\t</div>\n\t\t\t\t<span class=\"sis-data-range__label-divider\">-</span>\n\t\t\t\t<div fxFlex=\"49\">\n\t\t\t\t\t<sis-date-picker\n\t\t\t\t\t\t\t[id]=\"endDateId\"\n\t\t\t\t\t\t\t[localeInfo]=\"localeInfo\"\n                            (dateChange) = changeValueTo($event)\n\t\t\t\t\t\t\t[placeholder]=\"'portfolio.filter.date.range.choose.date' | sisTranslateMessage | async\"\n\t\t\t\t\t\t\t[(ngModel)]=\"toDate\"\n\t\t\t\t\t></sis-date-picker>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<sis-error [forControl]=\"dataRangeElement\" [isInput]=\"true\" [id]=\"'selenium-test-status-validation'\"\n\t\t\t\t\t   [errorMessage]=\"errorMessageKey | sisTranslateMessage | async\"></sis-error>\n\t\t</div>"
                },] },
    ];
    /** @nocollapse */
    SisDatesRangeViewComponent.ctorParameters = function () { return [
        { type: formatting_service_1.PortfolioFormattingService, },
    ]; };
    SisDatesRangeViewComponent.propDecorators = {
        "valueChange": [{ type: core_1.Output },],
        "from": [{ type: core_1.Input },],
        "to": [{ type: core_1.Input },],
        "fieldName": [{ type: core_1.Input },],
    };
    SisDatesRangeViewComponent = __decorate([
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<sis-date-range></sis-date-range>",
        }),
        __metadata("design:paramtypes", [formatting_service_1.PortfolioFormattingService])
    ], SisDatesRangeViewComponent);
    return SisDatesRangeViewComponent;
}());
exports.SisDatesRangeViewComponent = SisDatesRangeViewComponent;
//# sourceMappingURL=sis-date-range.component.js.map